// #910: when a browser blocks site data, even reading window.localStorage
// throws SecurityError. The cookie banner is in the root layout, so these
// helpers never throw: a blocked read means "no choice yet", and a blocked
// write just isn't remembered beyond this page view.

const CONSENT_KEY = 'cookie-consent'
const CONSENT_DATE_KEY = 'cookie-consent-date'

export type CookieConsentChoice = 'accepted' | 'declined'

const browserStorage = () => window.localStorage

export function readCookieConsent(getStorage: () => Storage = browserStorage): string | null {
  try {
    return getStorage().getItem(CONSENT_KEY)
  } catch {
    return null
  }
}

/** Returns false when the choice could not be stored. */
export function writeCookieConsent(
  choice: CookieConsentChoice,
  getStorage: () => Storage = browserStorage,
  now: Date = new Date(),
): boolean {
  try {
    const storage = getStorage()
    storage.setItem(CONSENT_KEY, choice)
    storage.setItem(CONSENT_DATE_KEY, now.toISOString())
    return true
  } catch {
    return false
  }
}
